<template>
  <div class="w-full rounded-full bg-gray-700 h-2">
    <div
      class="rounded-full h-full"
      :class="danger ? 'bg-linear-red' : 'bg-linear-green'"
      :style="{
        width: `${percentage}%`,
      }"
    />
  </div>
</template>

<script>
export default {
  name: "Bar",
  props: {
    percentage: { type: [Number, String], default: 0 },
    danger: { type: Boolean, default: false },
  },
};
</script>
